export function replaceS3WithCF(url) {
  return url
    .replace(
      'icm-prod-magento-media.s3.eu-central-1.amazonaws.com',
      'd1ht25obx4b8vc.cloudfront.net',
    )
    .replace('icm-magento-media.s3.ap-southeast-1.amazonaws.com', 'd1ei1cu82tkg5z.cloudfront.net')
    .replace('regna-static-media-cf.dev.regna.ai', 'd140o3th0axpm.cloudfront.net');
}
